<template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>
    <loading :loading="loading"></loading>
    <error-alert-dialog
      :show-error-alert-dialog="showErrorAlertDialog"
      :error="networkError" @dismissClicked="showErrorAlertDialog=false">
    </error-alert-dialog>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <div v-if="showUI" class="margin_top_40">
      <div class="item-heading-desc-div margin-left-20 margin-right-20">
        <weex-text class="item-heading ">{{chooseEmiDateHeading}}</weex-text>
      </div>
      <wxc-radio
        class="margin-left-20 margin-right-20 margin_top_20"
        :list="emiDates"
        :config="radioButtonConfig"
        :radio-button-on-right="false"
        @wxcRadioListChecked="emiDateSelected"></wxc-radio>

      <wxc-button
        text="Next"
        class="button_horizontal_center margin_top_20"
        type="blue"
        size="full"
        @wxcButtonClicked="saveEmiDate">
      </wxc-button>
    </div>
  </div>
</template>
<script>
import ToolBar from "../../layout/ToolBar";
import Loading from "../../layout/Loading";
import WxcButton from "@/../weex-ui/packages/wxc-button/index";
import WxcRadio from "@/../weex-ui/packages/wxc-radio/index";
import alertService from "@/components/core/alert/AlertService";
import { Constants } from "../../Constants";
import loanScopeDataHolder from "@/data/model/LoanScopeDataHolder";
import LoanTasksUtility from "@/utils/LoanTasksUtility";
import EzUtils from "@/utils/EzUtils";
import LoanTaskActivityNavigator from "@/utils/LoanTasksActivityNavigator";
import AttributeUtil from "@/utils/AttributeUtil";
import DataSource from "@/data/DataSource";
import ErrorAlertDialog from "@/components/dialogs/ErrorAlertDialog";
import { DefaultResourceConfig } from "@/utils/ImageResourcesUtil";
import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import { Activities } from "@/utils/ActivityNavigator";
import { MessageConstants } from "@/utils/MessageConstantUtil";
import StageCommentItem from "../../layout/StageCommentItem";
import storageUtil from "../../../utils/StorageUtil";

export default {
  name: "ChooseEmiDateActivity",
  components: {
    ActivityRedirectItem,
    ErrorAlertDialog,
    ToolBar,
    WxcButton,
    WxcRadio,
    Loading,
    StageCommentItem
  },
  data: () => ({
    toolbarTitle: "Choose EMI Date",
    emiDates: [],
    selectedDate: "",
    showUI: false,
    loading: false,
    showErrorAlertDialog: false,
    networkError: {},
  }),

  created: function () {
    this.loading = true;
    LoanTasksUtility.getLoanStageConfigData(loanScopeDataHolder.getLoanId(),
      loanScopeDataHolder.getCurrentLoanTask().name)
      .then(stageConfigDataRes => {
        this.loading = false;
        if (stageConfigDataRes.errorOccurred) {
          this.networkError = stageConfigDataRes.data;
          this.showErrorAlertDialog = true;
        } else {
          this.showUI = true;
          this.emiDates = [];
          stageConfigDataRes.data.properties[Constants.EMI_STAGE_AVAILABLE_DATES].forEach(
            emiDate => {
              this.emiDates.push({ title: emiDate, value: emiDate })
            });
        }
      })
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.CHOOSE_EMI_DATE];
    },

    currentTaskName() {
      return loanScopeDataHolder.getCurrentLoanTask()
        ? loanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    chooseEmiDateHeading() {
      return "Please select the date on which you want to get the First EMI deducted from your bank account.";
    },

    radioButtonConfig() {
      return DefaultResourceConfig.RADIO_BUTTON;
    },
  },

  methods: {
    emiDateSelected(e) {
      this.selectedDate = e.value
    },

    saveEmiDate() {
      if (this.checkForValidation()) {
        this.loading = true;
        const attributeDto = AttributeUtil.getAttributeUpdateDto(Constants.LOANS,
          loanScopeDataHolder.getLoanId(),
          AttributeUtil.getSingleAttributeData(Constants.EMI_REPAYMENT_KEY,
            Constants.EMI_REPAYMENT_NAME, this.selectedDate));
        DataSource.createOrUpdateAttribute(attributeDto)
          .then(res => {
            if (res.errorOccurred) {
              this.loading = false;
              this.networkError = res.data;
              this.showErrorAlertDialog = true;
            } else {
              this.getNextTask()
            }
          })
      }
    },

    checkForValidation() {
      if (!EzUtils.isValidString(this.selectedDate)) {
        alertService.showToast(MessageConstants.SELECT_CHOOSE_EMI_DATE_MESSAGE)
        return false;
      }
      return true;
    },

    getNextTask() {
      LoanTaskActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.networkError = res.data;
            this.showErrorAlertDialog = true;
          }
        });
    }
  }
}
</script>

<style scoped src="../../../assets/style/base.css"></style>

<style scoped>

</style>
